"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _useVideo = _interopRequireDefault(require("../../hooks/useVideo"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var NativeProvider = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var onCanPlay = props.onCanPlay,
    filteredProps = __rest(props, ["onCanPlay"]);
  var _a = (0, _useVideo.default)(),
    id = _a.id,
    src = _a.src,
    width = _a.width,
    height = _a.height,
    onReady = _a.onReady;
  var handleOnCanPlay = (0, _react.useCallback)(function (event) {
    onReady();
    if (typeof onCanPlay === 'function') {
      onCanPlay(event);
    }
  }, [onReady, onCanPlay]);
  return src ? (0, _jsxRuntime.jsx)("video", __assign({
    controls: true,
    id: "fluffy-native-player-".concat(id),
    width: width,
    height: height
  }, filteredProps, {
    onCanPlay: handleOnCanPlay,
    ref: ref
  }, {
    children: (0, _jsxRuntime.jsx)("source", {
      src: src
    })
  })) : null;
});
var _default = NativeProvider;
exports.default = _default;